import React, { useEffect, useState } from 'react'
import Layout from '../../components/shared/Layout/Layout'
import API from '../../services/API';
import { toast } from 'react-toastify';
import moment from 'moment';
const HospitalList = () => {
  const [data, setData] = useState([]);
  //find the donar records
  const getDonar = async () => {
    try {
      const { data } = await API.get("/admin/hospital-list");
      if (data?.success) {
        setData(data?.hospitalData);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getDonar();
  }, []);

  const handleDelete = async (id) => {
    try {
      let answer = window.confirm(
        "Are you sure you want to delete this record?",
        "Confirm Delete"
      );
      if (!answer) return;
      const { data } = await API.delete(`/admin/delete/${id}`);
      toast.success(data?.message);
      window.location.reload();
      if (data?.success) {
        getDonar();
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <Layout>
      <table className="table">
        <thead>
          <tr>
            <th scope="col">Name</th>
            <th scope="col">EmailID</th>
            <th scope="col">Phone</th>
            <th scope="col">Date</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((record) => (
            <tr key={record._id}>
              <td>{ record.hospitalName}</td>
              <td>{record.email}</td>
              <td>{record.phone}</td>
              <td>{moment(record.createdAt).format("DD/MM/YYYY hh:mm A")}</td>
              <td>
                <button
                  onClick={() => handleDelete(record._id)}
                  className="btn btn-danger"
                >
                  Delete <i className="fa-sharp fa-solid fa-trash"></i>{" "}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Layout>
  )
}

export default HospitalList